var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_102_3053)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2012 22.8C13.2012 23.4627 12.6639 24 12.0012 24H6.00117C3.35452 24 1.20117 21.8467 1.20117 19.2V4.8C1.20117 2.15334 3.35452 0 6.00117 0H12.0012C12.6638 0 13.2012 0.537281 13.2012 1.2C13.2012 1.86272 12.6639 2.4 12.0012 2.4H6.00117C4.67756 2.4 3.60117 3.47634 3.60117 4.8V19.2C3.60117 20.5236 4.67756 21.6 6.00117 21.6H12.0012C12.6639 21.6 13.2012 22.1373 13.2012 22.8ZM22.7085 12.4586C22.8299 12.1652 22.8299 11.8349 22.7085 11.5414C22.6477 11.3946 22.56 11.2618 22.4493 11.1512L17.6496 6.35156C17.1809 5.88281 16.4215 5.88281 15.9527 6.35156C15.484 6.82031 15.484 7.57969 15.9527 8.04844L18.7043 10.8H9.60117C8.9385 10.8 8.40117 11.3373 8.40117 12C8.40117 12.6627 8.9385 13.2 9.60117 13.2H18.7043L15.9527 15.9516C15.484 16.4203 15.484 17.1797 15.9527 17.6484C16.1871 17.8828 16.4941 18 16.8012 18C17.1082 18 17.4152 17.8828 17.6496 17.6484L22.4493 12.8488C22.56 12.7382 22.6477 12.6054 22.7085 12.4586Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_102_3053"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logoutIcon.7f4dca17f5601fba7c0d50b62fdcd749.svg";
export { ForwardRef as ReactComponent };